import { EditGuesser } from "@api-platform/admin";
import {MedicalAdviceForm} from "../components/MedicalAdviceForm";

export const MedicalAdviceEdit = props => (
<EditGuesser {...props}>
    <MedicalAdviceForm />
</EditGuesser>
);
